import { RESPONSE_TYPE } from "../const/vote";
import { BasicTextReview } from "./basic_text/basic-text-review";
import { FirstPastReview } from "./check_list/check-list-review";
import { PreferenceReview } from "./preference/preference-review";
import { BalllotReviewProps } from "./types";
import { YesNoReview } from "./yes_no/yes-no-review";

export interface IReviewMuxProps extends BalllotReviewProps<any> {
    response_type: RESPONSE_TYPE
}

export const ReviewMux = (props: BalllotReviewProps<any>) => {
    const { response_type } = props.question;
    switch (response_type) {
        case RESPONSE_TYPE.PREFERENCE:
            return <PreferenceReview {...props} />;

        case RESPONSE_TYPE.CHECK_LIST:
            return <FirstPastReview {...props} />;

        case RESPONSE_TYPE.YES_NO:
            return <YesNoReview {...props} />;

        case RESPONSE_TYPE.BASIC_TEXT:
            return <BasicTextReview {...props} />;
    }
}